(function ($) {
  ("use strict");
  Drupal.behaviors.buildResourcesSlider = {
    attach: function (context) {
      // Initialize resources slider
      $(".resources-slider__wrapper", context).slick({
        autoplay: false,
        speed: 300,
        infinite: true,
        mobileFirst: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        appendArrows: $(".resources-slider__controls"),
        responsive: [
          {
            breakpoint: 420,
            settings: {
              slidesToShow: 4,
            },
          },
        ],
      });
    },
  };
})(jQuery);
